import type {
  MbcAdminCheck,
  MbcAdminCriterion,
  MbcAdminGuidelineBody,
} from "@nlc/shared-types";

export const REQUIRED_TOTAL_WEIGHT = 100;

export function totalWeight(criteria: MbcAdminCriterion[]): number {
  return criteria.reduce((sum, { weight }) => sum + weight, 0);
}

export function toBody({
  checkKeys,
  checks,
  criteria,
  guideline,
  name,
}: {
  checkKeys: string[];
  checks: MbcAdminCheck[];
  criteria: MbcAdminCriterion[];
  guideline: string;
  name: string;
}): MbcAdminGuidelineBody {
  const criterionFields = new Set(criteria.map(({ briefField }) => briefField));
  const fieldsByKey = new Map(checks.map(({ field, key }) => [key, field]));

  return {
    checkKeys: checkKeys.filter((key) =>
      criterionFields.has(fieldsByKey.get(key)!),
    ),
    criteria,
    guideline: guideline.trim() || null,
    name,
  };
}
